// Touch-pad faces whose letters or arrangement differ from the system table's button names.
// The cores never read these, and src/client/cores/systems.js is pinned by the replay
// checkpoint profiles, so this presentation lives here.
const TOUCH_FACES = Object.freeze({
  // Genesis Plus GX takes Genesis A as Y, B as B, C as A, X as X, Y as L, Z as R and Mode as
  // SELECT (systems.js). The pad shows the Genesis letters, X Y Z over A B C, with no shoulders;
  // before this it showed the SNES letters, so Genesis A read "Y".
  genesis: Object.freeze({
    labels: Object.freeze({ Y: 'A', B: 'B', A: 'C', X: 'X', L: 'Y', R: 'Z', SELECT: 'MODE' }),
    six: Object.freeze({ top: Object.freeze(['X', 'L', 'R']), bottom: Object.freeze(['Y', 'B', 'A']) }),
  }),
});

/** The system's touch face override, or null when the system table's names are the letters. */
export function touchFaceFor(system) {
  return TOUCH_FACES[system?.id] ?? null;
}
